import { MainRouter } from './routing/router-config';

const App: React.FC = () => <MainRouter />;

export default App;
